class ShopTheLook {
  constructor() {
    this.activePopup = null;
    this.overlay = document.querySelector('[data-overlay]');
    this.carousel = document.querySelector('.shop-the-look__carousel');
    this.slidesContainer = document.querySelector('[data-slides-container]');
    this.slides = [];
    this.currentSlide = 0;
    this.totalSlides = 0;
    this.autoPlayInterval = null;
    this.isAutoPlaying = false;
    this.touchStartX = 0;
    this.touchEndX = 0;
    
    console.log('Shop the Look initialized');
    this.init();
  }

  init() {
    this.setupCarousel();
    this.bindEvents();
    this.startAutoPlay();
    console.log('Shop the Look initialized and events bound');
  }

  setupCarousel() {
    if (!this.carousel) return;
    
    this.slides = Array.from(document.querySelectorAll('.shop-the-look__slide'));
    this.totalSlides = this.slides.length;
    
    if (this.totalSlides <= 1) return;
    
    // Set initial active slide
    this.slides.forEach((slide, index) => {
      slide.classList.toggle('active', index === 0);
    });
    
    // Set initial active dot
    this.updateDots();
    
    console.log(`Carousel setup complete: ${this.totalSlides} slides`);
  }

  bindEvents() {
    // === CAROUSEL NAVIGATION ===
    // Previous button
    const prevBtn = document.querySelector('[data-carousel-prev]');
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.prevSlide();
      });
    }

    // Next button
    const nextBtn = document.querySelector('[data-carousel-next]');
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextSlide();
      });
    }

    // Dot navigation
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-slide-dot]')) {
        e.preventDefault();
        const slideIndex = parseInt(e.target.dataset.slideDot);
        this.goToSlide(slideIndex);
      }
    });

    // Touch/Swipe support
    if (this.carousel) {
      this.carousel.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
        this.pauseAutoPlay();
      });

      this.carousel.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
        this.resumeAutoPlay();
      });

      // Pause autoplay on hover
      this.carousel.addEventListener('mouseenter', () => {
        this.pauseAutoPlay();
      });

      this.carousel.addEventListener('mouseleave', () => {
        this.resumeAutoPlay();
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (this.totalSlides <= 1) return;
      
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.nextSlide();
      }
    });

    // === EXISTING PIN/POPUP FUNCTIONALITY ===
    // Pin clicks
    document.addEventListener('click', (e) => {
      if (e.target.closest('.shop-the-look__pin')) {
        e.preventDefault();
        const pin = e.target.closest('.shop-the-look__pin');
        const hotspotId = pin.dataset.hotspotId;
        this.openPopup(hotspotId);
      }
    });

    // Close popup buttons
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-close-popup]')) {
        e.preventDefault();
        this.closeActivePopup();
      }
    });

    // Overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.closeActivePopup();
      });
    }

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.activePopup) {
        this.closeActivePopup();
      }
    });

    // Add to cart forms
    document.addEventListener('submit', (e) => {
      if (e.target.matches('.shop-the-look__product-form')) {
        e.preventDefault();
        console.log('Form submitted:', e.target);
        this.handleAddToCart(e.target);
      }
    });

    // Add all products button
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-add-all-products]')) {
        e.preventDefault();
        const hotspotId = e.target.dataset.addAllProducts;
        this.addAllProductsToCart(hotspotId);
      }
    });
  }

  // === CAROUSEL METHODS ===
  nextSlide() {
    if (this.totalSlides <= 1) return;
    this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    this.updateSlide();
  }

  prevSlide() {
    if (this.totalSlides <= 1) return;
    this.currentSlide = this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1;
    this.updateSlide();
  }

  goToSlide(index) {
    if (this.totalSlides <= 1 || index < 0 || index >= this.totalSlides) return;
    this.currentSlide = index;
    this.updateSlide();
  }

  updateSlide() {
    // Update slides - usar visibility en lugar de transform
    this.slides.forEach((slide, index) => {
      slide.classList.toggle('active', index === this.currentSlide);
    });

    // Update dots
    this.updateDots();

    console.log(`Moved to slide ${this.currentSlide + 1} of ${this.totalSlides}`);
  }

  updateDots() {
    const dots = document.querySelectorAll('[data-slide-dot]');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentSlide);
    });
  }

  handleSwipe() {
    const swipeThreshold = 50;
    const diff = this.touchStartX - this.touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swiped left - go to next slide
        this.nextSlide();
      } else {
        // Swiped right - go to previous slide
        this.prevSlide();
      }
    }
  }

  // === AUTO-PLAY FUNCTIONALITY ===
  startAutoPlay() {
    const carouselElement = document.querySelector('.shop-the-look');
    if (!carouselElement || this.totalSlides <= 1) return;
    
    const isAutoPlayEnabled = carouselElement.dataset.autoPlay === 'true';
    const autoPlaySpeed = carouselElement.dataset.autoPlaySpeed || 5;
    
    if (isAutoPlayEnabled) {
      this.isAutoPlaying = true;
      this.autoPlayInterval = setInterval(() => {
        if (this.isAutoPlaying) {
          this.nextSlide();
        }
      }, autoPlaySpeed * 1000);
      
      console.log(`Auto-play started: ${autoPlaySpeed}s interval`);
    }
  }

  pauseAutoPlay() {
    this.isAutoPlaying = false;
  }

  resumeAutoPlay() {
    this.isAutoPlaying = true;
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
      this.isAutoPlaying = false;
    }
  }

  // === EXISTING POPUP FUNCTIONALITY ===
  openPopup(hotspotId) {
    this.closeActivePopup(); // Close any existing popup first
    
    // Buscar primero los popups que están FUERA de los slides (no los que tienen --slide)
    let popup = document.querySelector(`[data-popup-id="${hotspotId}"]:not(.shop-the-look__popup--slide)`);
    
    // Si no encuentra, buscar cualquier popup con ese ID
    if (!popup) {
      popup = document.querySelector(`[data-popup-id="${hotspotId}"]`);
    }
    
    if (!popup) return;

    // Pause carousel while popup is open
    this.pauseAutoPlay();

    this.activePopup = popup;
    
    // Show overlay
    if (this.overlay) {
      this.overlay.classList.add('active');
    }
    
    // Show popup
    popup.classList.add('active');
    popup.setAttribute('aria-hidden', 'false');
    
    // Focus management
    const firstFocusable = popup.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) {
      firstFocusable.focus();
    }
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  closeActivePopup() {
    if (!this.activePopup) return;
    
    // Hide overlay
    if (this.overlay) {
      this.overlay.classList.remove('active');
    }
    
    // Hide popup
    this.activePopup.classList.remove('active');
    this.activePopup.setAttribute('aria-hidden', 'true');
    
    // Restore body scroll
    document.body.style.overflow = '';
    
    // Resume carousel autoplay
    this.resumeAutoPlay();
    
    this.activePopup = null;
  }

  // === CART FUNCTIONALITY ===
  async handleAddToCart(form) {
    const submitBtn = form.querySelector('.shop-the-look__add-to-cart-btn');
    const originalText = submitBtn.textContent;
    
    console.log('Adding to cart - Form:', form);
    
    // Set loading state
    submitBtn.classList.add('loading');
    submitBtn.textContent = 'Agregando...';
    submitBtn.disabled = true;

    try {
      const formData = new FormData(form);
      
      // Get the variant ID and quantity
      const variantId = formData.get('id');
      const quantity = formData.get('quantity') || 1;
      
      console.log('Variant ID:', variantId, 'Quantity:', quantity);
      
      if (!variantId || variantId === '') {
        throw new Error('No se pudo obtener el ID del producto');
      }

      const requestBody = {
        items: [{
          id: parseInt(variantId),
          quantity: parseInt(quantity)
        }]
      };
      
      console.log('Request body:', requestBody);

      // Use fetch to add to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      console.log('Response status:', response.status);
      
      const result = await response.json();
      console.log('Response result:', result);

      if (response.ok) {
        console.log('Product added successfully!');
        
        // Success state
        submitBtn.classList.remove('loading');
        submitBtn.classList.add('success');
        submitBtn.textContent = '✓ Agregado';
        
        // Update cart content only (preserving styles)
        await this.updateCartContentOnly();
        
        // Reset button after 2 seconds
        setTimeout(() => {
          submitBtn.classList.remove('success');
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);
        
      } else {
        // Handle Shopify API errors
        const errorMessage = result.message || result.description || 'Error adding products to cart';
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      
      // Error state
      submitBtn.classList.remove('loading');
      submitBtn.textContent = 'Error - Intenta de nuevo';
      submitBtn.style.background = '#dc3545';
      
      // Show error message if available
      if (error.message.includes('sold out') || error.message.includes('agotado')) {
        submitBtn.textContent = 'Producto agotado';
      }
      
      // Reset button after 3 seconds
      setTimeout(() => {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
        submitBtn.style.background = '';
      }, 3000);
    }
  }

  async addAllProductsToCart(hotspotId) {
    const popup = document.querySelector(`[data-popup-id="${hotspotId}"]`);
    if (!popup) return;

    const forms = popup.querySelectorAll('.shop-the-look__product-form');
    const addAllBtn = popup.querySelector('[data-add-all-products]');
    const originalText = addAllBtn.textContent;
    
    // Set loading state
    addAllBtn.classList.add('loading');
    addAllBtn.textContent = 'Agregando productos...';
    addAllBtn.disabled = true;

    const items = [];
    
    // Collect all form data
    forms.forEach(form => {
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const quantity = formData.get('quantity') || 1;
      
      if (variantId && variantId !== '') {
        items.push({
          id: parseInt(variantId),
          quantity: parseInt(quantity)
        });
      }
    });

    if (items.length === 0) {
      // No items to add
      addAllBtn.classList.remove('loading');
      addAllBtn.textContent = 'There are no products to add';
      setTimeout(() => {
        addAllBtn.textContent = originalText;
        addAllBtn.disabled = false;
      }, 2000);
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const result = await response.json();

      if (response.ok) {
        // Success state
        addAllBtn.classList.remove('loading');
        addAllBtn.classList.add('success');
        addAllBtn.textContent = `✓ ${items.length} productos agregados`;
        
        // Update individual buttons
        forms.forEach(form => {
          const btn = form.querySelector('.shop-the-look__add-to-cart-btn');
          if (btn && !btn.disabled) {
            btn.classList.add('success');
            btn.textContent = '✓ Agregado';
          }
        });
        
        // Update cart content only (preserving styles)
        await this.updateCartContentOnly();
        
        // Reset after 3 seconds
        setTimeout(() => {
          addAllBtn.classList.remove('success');
          addAllBtn.textContent = originalText;
          addAllBtn.disabled = false;
          
          forms.forEach(form => {
            const btn = form.querySelector('.shop-the-look__add-to-cart-btn');
            if (btn && btn.classList.contains('success')) {
              btn.classList.remove('success');
              btn.textContent = 'Add to cart';
            }
          });
        }, 3000);
        
      } else {
        // Handle Shopify API errors
        const errorMessage = result.message || result.description || 'Error adding products to cart';
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error('Error adding all to cart:', error);
      
      // Error state
      addAllBtn.classList.remove('loading');
      addAllBtn.textContent = 'Error - Intenta de nuevo';
      addAllBtn.style.background = '#dc3545';
      
      setTimeout(() => {
        addAllBtn.textContent = originalText;
        addAllBtn.disabled = false;
        addAllBtn.style.background = '';
      }, 3000);
    }
  }

  // === CART UPDATE FUNCTIONALITY === 
  async updateCartContentOnly() {
    try {
      console.log('🛒 Updating cart content only...');
      
      // 1. Update cart count
      await this.updateCartCount();
      
      // 2. Update ONLY cart drawer content (preserving styles)
      await this.refreshCartDrawerContentOnly();
      
      // 3. Open drawer using native Dawn methods
      this.openCartDrawerNative();
      
      // 4. Dispatch native Dawn event
      this.dispatchNativeCartEvent();
      
      console.log('✅ Cart content updated successfully (styles preserved)');
      
    } catch (error) {
      console.error('❌ Error updating cart content:', error);
      this.showSuccessMessage('✓ Producto agregado al carrito');
    }
  }

  async updateCartCount() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Only update counter text, not styles
      const cartCountElements = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
      cartCountElements.forEach(element => {
        if (element) {
          element.textContent = cart.item_count;
          // Only change visibility if necessary, don't touch other styles
          if (cart.item_count > 0) {
            element.classList.remove('visually-hidden');
          } else {
            element.classList.add('visually-hidden');
          }
        }
      });
      
      return cart;
    } catch (error) {
      console.error('Error updating cart count:', error);
      return null;
    }
  }

  async refreshCartDrawerContentOnly() {
    try {
      console.log('🔄 Refreshing cart drawer content (preserving styles)...');
      
      // Check if cart was empty BEFORE update
      const cartDrawer = document.querySelector('cart-drawer');
      const wasEmpty = cartDrawer && cartDrawer.classList.contains('is-empty');
      
      // Get updated HTML for cart drawer
      const response = await fetch('/?section_id=cart-drawer');
      if (!response.ok) throw new Error('Failed to fetch cart drawer section');
      
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      
      // SPECIAL CASE: Transition from empty cart → cart with products
      if (wasEmpty) {
        console.log('🔄 Handling empty → with products transition...');
        
        // Remove is-empty class from cart drawer
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
        }
        
        // Update ALL inner content of drawer for complete transition
        const drawerInner = document.querySelector('.drawer__inner');
        const newDrawerInner = html.querySelector('.drawer__inner');
        
        if (drawerInner && newDrawerInner) {
          drawerInner.innerHTML = newDrawerInner.innerHTML;
          console.log('✅ Complete drawer inner updated (empty → with products)');
          return;
        }
      }
      
      // NORMAL CASE: Products already exist, only update specific parts
      console.log('🔄 Updating existing cart content...');
      
      // Update ONLY inner parts containing products
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      const newCartDrawerItems = html.querySelector('cart-drawer-items');
      
      if (cartDrawerItems && newCartDrawerItems) {
        // Only update innerHTML to preserve web component
        cartDrawerItems.innerHTML = newCartDrawerItems.innerHTML;
        console.log('✅ Cart items updated (web component preserved)');
      }
      
      // Update drawer footer (totals, checkout button)
      const drawerFooter = document.querySelector('.cart-drawer__footer');
      const newDrawerFooter = html.querySelector('.cart-drawer__footer');
      
      if (drawerFooter && newDrawerFooter) {
        drawerFooter.innerHTML = newDrawerFooter.innerHTML;
        console.log('✅ Cart footer updated (styles preserved)');
      }
      
    } catch (error) {
      console.error('Error refreshing cart drawer content:', error);
      throw error;
    }
  }

  openCartDrawerNative() {
    try {
      // Method 1: Use native Dawn web component
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        console.log('📱 Opening cart drawer using native method');
        cartDrawer.open();
        return;
      }
      
      // Method 2: Simulate click on cart icon
      const cartIcon = document.querySelector('.header__icon--cart, .cart-count-bubble');
      if (cartIcon) {
        console.log('🎯 Opening cart drawer via cart icon click');
        cartIcon.click();
        return;
      }
      
      // Method 3: Fallback - show notification
      console.log('ℹ️ No native cart drawer method found, showing notification');
      this.showSuccessMessage('✓ Producto agregado al carrito');
      
    } catch (error) {
      console.error('Error opening cart drawer:', error);
      this.showSuccessMessage('✓ Producto agregado al carrito');
    }
  }

  dispatchNativeCartEvent() {
    try {
      // Only dispatch events that Dawn actually listens to
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { source: 'shop-the-look' }
      }));
    } catch (error) {
      console.error('Error dispatching cart event:', error);
    }
  }

  showSuccessMessage(message) {
    // Remove any existing notifications
    const existing = document.querySelectorAll('.shop-the-look-notification');
    existing.forEach(el => el.remove());
    
    // Create success notification
    const notification = document.createElement('div');
    notification.className = 'shop-the-look-notification';
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
      z-index: 10000;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 8px;
      animation: slideInRight 0.3s ease-out;
    `;
    
    notification.innerHTML = `
      ${message}
      <button onclick="this.parentElement.remove()" style="
        background: none;
        border: none;
        color: white;
        margin-left: 8px;
        cursor: pointer;
        font-size: 18px;
        padding: 0;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      ">×</button>
    `;
    
    // Add CSS if not exists
    if (!document.querySelector('#shop-the-look-notification-styles')) {
      const style = document.createElement('style');
      style.id = 'shop-the-look-notification-styles';
      style.textContent = `
        @keyframes slideInRight {
          from { 
            transform: translateX(100%); 
            opacity: 0; 
          }
          to { 
            transform: translateX(0); 
            opacity: 1; 
          }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(notification);
    
    // Auto remove after 4 seconds
    setTimeout(() => {
      if (notification.parentElement) {
        notification.style.animation = 'slideInRight 0.3s ease-out reverse';
        setTimeout(() => notification.remove(), 300);
      }
    }, 4000);
  }

  // === UTILITY METHODS ===
  destroy() {
    this.stopAutoPlay();
    this.closeActivePopup();
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.shopTheLookInstance = new ShopTheLook();
});

// Reinitialize for theme editor
document.addEventListener('shopify:section:load', () => {
  if (window.shopTheLookInstance) {
    window.shopTheLookInstance.destroy();
  }
  window.shopTheLookInstance = new ShopTheLook();
});

// Handle variant changes
document.addEventListener('change', (e) => {
  if (e.target.matches('.shop-the-look__variant-select')) {
    const form = e.target.closest('.shop-the-look__product-form');
    const submitBtn = form.querySelector('.shop-the-look__add-to-cart-btn');
    const variantId = e.target.value;
    
    console.log('Variant changed to:', variantId);
    
    // Enable/disable button based on variant availability
    const selectedOption = e.target.selectedOptions[0];
    const isAvailable = selectedOption && !selectedOption.disabled && variantId !== '';
    
    submitBtn.disabled = !isAvailable;
    submitBtn.textContent = isAvailable ? 'Add to cart' : 'sold out';
    
    // Update button style based on availability
    if (isAvailable) {
      submitBtn.style.background = '';
      submitBtn.style.cursor = 'pointer';
      submitBtn.style.opacity = '1';
    } else {
      submitBtn.style.background = '#ccc';
      submitBtn.style.cursor = 'not-allowed';
      submitBtn.style.opacity = '0.6';
    }
    
    console.log('Button updated - Available:', isAvailable, 'Text:', submitBtn.textContent);
  }
});

// === DEBUG UTILITIES ===
window.shopTheLookDebug = function() {
  console.log('=== Shop the Look Debug ===');
  
  // Basic component info
  const pins = document.querySelectorAll('.shop-the-look__pin');
  const popups = document.querySelectorAll('.shop-the-look__popup');
  const forms = document.querySelectorAll('.shop-the-look__product-form');
  const slides = document.querySelectorAll('.shop-the-look__slide');
  
  console.log(`Pins found: ${pins.length}`);
  console.log(`Popups found: ${popups.length}`);
  console.log(`Forms found: ${forms.length}`);
  console.log(`Slides found: ${slides.length}`);
  
  // Carousel info
  if (window.shopTheLookInstance) {
    console.log(`Current slide: ${window.shopTheLookInstance.currentSlide + 1} of ${window.shopTheLookInstance.totalSlides}`);
    console.log(`Auto-play active: ${window.shopTheLookInstance.isAutoPlaying}`);
  }
  
  // Check cart drawer
  const cartDrawer = document.querySelector('cart-drawer');
  console.log('Cart Drawer:', !!cartDrawer);
  if (cartDrawer) {
    console.log('  - Has open method:', typeof cartDrawer.open === 'function');
  }
  
  // Test current cart
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log(`Current cart: ${cart.item_count} items, $${(cart.total_price / 100).toFixed(2)}`);
    })
    .catch(error => console.error('Cart API error:', error));
};

// Test carousel navigation
window.shopTheLookTestCarousel = function() {
  if (window.shopTheLookInstance) {
    console.log('🧪 Testing carousel navigation...');
    setTimeout(() => window.shopTheLookInstance.nextSlide(), 1000);
    setTimeout(() => window.shopTheLookInstance.nextSlide(), 2000);
    setTimeout(() => window.shopTheLookInstance.prevSlide(), 3000);
    setTimeout(() => window.shopTheLookInstance.goToSlide(0), 4000);
  } else {
    console.error('Shop the Look instance not found');
  }
};

// Test content update
window.shopTheLookTestContentUpdate = async function() {
  if (window.shopTheLookInstance) {
    console.log('🧪 Testing content-only update...');
    await window.shopTheLookInstance.updateCartContentOnly();
  } else {
    console.error('Shop the Look instance not found');
  }
};